<template>
  <div>
    <h6>{{ question.label }} {{ question.required ? '*' : '' }}</h6>
    <div class="mb-2" v-html="question.description"></div>
    <b-form-group>
      <b-form-checkbox-group
        v-if="question.options.multiple"
        stacked
        v-model="answers"
        :options="dateOptions"
        :disabled="disabled"
      ></b-form-checkbox-group>
      <b-form-radio-group
        v-if="!question.options.multiple && dateOptions.length <= 4"
        stacked
        v-model="answer"
        :options="dateOptions"
        :disabled="disabled"
      ></b-form-radio-group>
      <b-form-select
        v-if="!question.options.multiple && dateOptions.length > 4"
        v-model="answer"
        :options="dateOptions"
        :disabled="disabled"
      ></b-form-select>
      <b-button v-if="!question.options.multiple && !!answer && !question.required" variant="link" size="sm" class="px-0 text-muted" @click="answer = null">
        {{ trans('clear') }}
      </b-button>
      <b-form-invalid-feedback :state="!!errors ? false : null">
        {{ (errors||[]).join(' ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
  function decode(value) {
    if (!value) return [undefined, undefined]
    let parts = value.split('&')
    let date = decodeURIComponent(parts[0])
    let label = parts.length > 1 ? decodeURIComponent(parts[1]) : undefined
    return [date, label]
  }
  function encode(date, label) {
    if (!date) return null
    return _.compact([
      encodeURIComponent(date),
      label ? encodeURIComponent(label) : undefined
    ]).join('&')
  }
  function normalize(value) {
    if (!value) return value
    let [date, label] = decode(value)
    return encode(date, label)
  }

  export default {
    props: {
      value: Array, // ISO dates
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      errors: Array,
    },
    data() {
      return {
        trans: trans,
        answers: _.map(_.compact(_.isArray(this.value) ? _.clone(this.value) : [this.value]), value => {return normalize(value)}),
        answer: normalize(_.isArray(this.value) ? this.value[0] || null : this.value || null)
      }
    },
    computed: {
      dateOptions() {
        return (this.question.options.values || []).map((date, index) => {
          let label = this.question.options.labels &&
            this.question.options.labels[index] ?
            this.question.options.labels[index] :
            null
          let text = _.compact([
            label,
            moment(date).format(this.question.options.date_only ? 'LL' : 'LLL')
          ]).join(' - ')
          let value = encode(_.toISOString6(moment(date)), label)
          let disabled = false
          if (this.question.options.limits) {
            const limit = this.question.options.limits[index]
            if (limit === 0) disabled = true
            if (_.isNumeric(limit)) text += ' (' + Math.max(0, limit) + ')'
          }
          return {
            value: value,
            text: text,
            disabled: disabled
          }
        })
      },
    },
    watch: {
      answers() {
        if (this.question.options.multiple && !_.isEqual(this.value, this.answers))
          this.$emit('input', this.answers)
      },
      answer() {
        if (!this.question.options.multiple && !_.isEqual(this.value, [this.answer]))
          this.$emit('input', [this.answer])
      },
      value() {
        this.answers = _.map(_.compact(_.isArray(this.value) ? _.clone(this.value) : [this.value]), value => {return normalize(value)})
        this.answer = normalize(_.isArray(this.value) ? this.value[0] || null : this.value || null)
      },
    },
    mounted() {
      window['questionDateSelection'+this.question.id] = this
    },
  }
</script>